import React from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Icon } from "@material-ui/core";

import LinkBtn from "../Buttons/LinkBtn";
import ExternalLinkBtn from "../Buttons/ExternalLinkBtn";
import useStyles from "../../MUIClasses/useStyles";

const MainCard = ({ title, description, target, onClick, linkBtn, icon, externalLink, iconColor }) => {

    return (
        <Grid item xs={12} md={4}>
            <Paper className={useStyles().paper} onClick={onClick}>
                <div className={useStyles().box}>
                    <Typography
                        style={{ textTransform: "uppercase" }}
                        color="secondary"
                        gutterBottom
                    >
                        {title}
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                        {description}
                    </Typography>
                </div>
                {linkBtn && (
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <LinkBtn
                            pathTo={target} icon={
                                <React.Fragment>
                                    <Icon style={{ marginRight: '5px' }} className={iconColor}>
                                        {icon}
                                    </Icon>
                                </React.Fragment>
                            } />
                    </div>
                )}
                {externalLink && (
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <ExternalLinkBtn
                            pathTo={target} icon={
                                <React.Fragment>
                                    <Icon style={{ marginRight: '5px' }} >
                                        {icon}
                                    </Icon>
                                    &#8594;
                                </React.Fragment>
                            } />
                    </div>
                )}
            </Paper>
        </Grid>

    );
}

export default MainCard;
